module.exports = __webpack_public_path__ + "img/good-03.16f381b8.png";